module.exports = __webpack_public_path__ + "images/stop.f966ac567403141da034f45ffefa9c9e.svg";